import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateCommunicationService {
  private dateRangeSource = new BehaviorSubject<{ startDate: string | null, endDate: string | null }>({ startDate: null, endDate: null });
  public currentDateRange$ = this.dateRangeSource.asObservable();

  public updateDateRange(startDate: string, endDate: string): void {
    this.dateRangeSource.next({ startDate, endDate });
  }
}